import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../core/providers/AuthProvider';
import { useNavigation } from '../../../../navigation/NavigationProvider';
import { Button } from '../../../../core/design-system/components/Button';
import { Input } from '../../../../core/design-system/components/Input';
import { Text } from '../../../../core/design-system/components/Text';
import GoogleAuthButton from '../../components/buttons/GoogleAuthButton/index';
// AppleAuthButton retiré pour beta GPT Store (RAS-41)
import { Logo } from '../../../../core/design-system/components/Logo';
import PasswordReset from '../../components/PasswordReset';
import './styles.css';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const { signIn } = useAuth();
  const { goToDashboard, openSignUp } = useNavigation();
  const { t } = useTranslation('auth');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!email) newErrors.email = t('errors.required_field');
    if (!password) newErrors.password = t('errors.required_field');

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    try {
      await signIn(email, password);
      goToDashboard();
    } catch (error) {
      console.error('Erreur de connexion:', error);
      if (error.code === 'auth/invalid-email') {
        setErrors({ email: t('errors.invalid_email') });
      } else if (error.code === 'auth/wrong-password') {
        setErrors({ password: t('errors.invalid_password') });
      } else {
        setErrors({ general: t('errors.default') });
      }
    }
  };

  if (showPasswordReset) {
    return <PasswordReset onClose={() => setShowPasswordReset(false)} />;
  }

  return (
    <div className="signin-content">
      <div className="signin-header">
        <Logo size={56} />
        <Text variant="h1" className="signin-title">
          {t('login.title')}
        </Text>
      </div>

      <div className="social-buttons">
        <GoogleAuthButton />
      </div>

      <div className="divider">{t('login.divider')}</div>

      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <Input
            type="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrors({ ...errors, email: undefined });
            }}
            placeholder={t('login.email')}
            fullWidth
            error={errors.email}
          />
          {errors.email && <div className="field-error">{errors.email}</div>}
        </div>

        <div className="input-container">
          <Input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrors({ ...errors, password: undefined });
            }}
            placeholder={t('login.password')}
            fullWidth
            error={errors.password}
          />
          {errors.password && <div className="field-error">{errors.password}</div>}
        </div>

        <Button type="submit" variant="primary" size="lg" fullWidth>
          {t('login.submit')}
        </Button>
      </form>

      <div className="auth-links">
        <button 
          className="text-link"
          onClick={() => setShowPasswordReset(true)}
        >
          {t('login.forgot_password')}
        </button>
        <div className="signup-prompt">
          <Text variant="body2" component="span">
            {t('login.no_account')}
          </Text>
          <button 
            className="text-link"
            onClick={openSignUp}
          >
            {t('login.signup_link')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignIn; 